import { Component, ElementRef, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderEntryService } from '../../services/order-entry.service';
import { ChangeDetectorRef } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { TagModule } from 'primeng/tag';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TableComponent } from '../components/table/table.component';
import { TabsModule } from 'primeng/tabs';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { environment } from '../../environments/environment';
import { MyMonitoringService } from '../../services/logging.service';
import { DialogModule } from 'primeng/dialog';
import { DropdownComponent } from '../components/dropdown/dropdown.component';
import { ActivatedRoute, Router } from '@angular/router';
import { TextinputComponent } from '../components/textinput/textinput.component';
import { ButtonComponent } from '../components/button/button.component';
import { ApiResponse, CustomerCallRecord, Dispatch, Emergencies, HistoryLogs, RequestPayload } from './order-entry-model/order-entry.model';
import { SSNMaskerDirective } from '../helper/ssn-mask.directive';
import { PhoneFormatDirective } from '../helper/phone-format.directive';
import { FormBuilder, FormsModule, NgForm } from '@angular/forms';
import { CityLoadData, OrderTypeData, AdvisoriesData } from '../interfaces/OrderEntryRecords';
import { ReconnectComponent } from '../reconnect/reconnect.component';
import { DatePipe } from '@angular/common';
import { DatePickerModule } from 'primeng/datepicker';
import { CallChecklistComponent } from '../call-checklist/call-checklist.component';
import { CallCheckListPayload } from './order-entry-model/call-checklist-model';
import { CallCheckListService } from '../../services/call-checklist.service';
import { RadioButtonComponent } from '../components/radiobutton/radiobutton.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TextareaComponent } from '../components/textarea/textarea.component';
import { MoveInComponent } from './components/move-in-form/move-in-form.component';
import { MoveOutComponent } from './components/move-out-form/move-out-form.component';
import { DispatchDataComponent } from "../dispatch-data/dispatch-data.component";
import { DispatchDataPayload } from "./order-entry-model/dispatch-request.model";
import { forkJoin, Observable, of, switchMap } from 'rxjs';
import { Appconstants } from '../utils/appconstants';
import { ControlUtils } from '../utils/control-utils';
import { ApiService } from '../../services/apiservice';
import { OrderEntrySharedService } from '../../services/order-entry-shared.service';
import leakageTypeData from '../call-checklist/leakage-by-emergency.json'
import { FloatLabelModule } from 'primeng/floatlabel';
import { SeverityLevel } from '@microsoft/applicationinsights-web';

@Component({
  selector: 'app-order-entry',
  imports: [DialogModule, TableModule, ButtonComponent, FloatLabelModule,
    TextinputComponent, TabsModule, ToastModule, CommonModule, TagModule,
    ButtonModule, SSNMaskerDirective, PhoneFormatDirective, InputTextModule, FormsModule,
    ProgressSpinnerModule, FormsModule, DropdownComponent, DatePickerModule,
    ReconnectComponent, CallChecklistComponent, RadioButtonComponent, TextareaComponent, MoveInComponent, MoveOutComponent,
    DispatchDataComponent],
  providers: [MessageService, OrderEntryService, MyMonitoringService, DatePipe, OrderEntrySharedService],
  templateUrl: './order-entry.component.html',
  styleUrl: './order-entry.component.scss',
  standalone: true,
})

export class OrderEntryComponent {
  @ViewChild('advisoryDiv') advisoryDiv: ElementRef | undefined;
  orderTypeDropdownOptions: string[] = [];
  reconnectSelectedDate: Date | null = null;
  reconnectformatedDate: string | null = null;
  isReconnect: boolean = false;
  orderTypeSelectedValue: string = '';
  StateDropdownOptions: any;
  getAllCity: any;
  stateSelectedValue: string = '';
  CityDropdownOptions: any;
  citySelectedValue: string = '';
  isLoading: boolean = true;
  isSuccess: boolean = false;
  isFailure: boolean = false;
  cityNamePayLoad!: CityLoadData[];
  orderTypePayLoad!: OrderTypeData[];
  requestPayload: RequestPayload | null = null;
  callCheckListPayload: CallCheckListPayload | null = null;
  dispatchDataPayload: DispatchDataPayload | null = null;
  isCallChekList: boolean = false;
  buildingDropdownOptions: { key: string, value: string }[] = [];
  buildingSelectedValue: string = '';
  leakedDropdownOptions: { key: string, value: string }[] = [];
  leakedSelectedValue: string = '';
  showDiv: boolean = false;
  isRightPanel: boolean = false;
  isPageLoad: boolean = false;
  isFirstLoad: boolean = true;
  isCity: boolean = false;
  cityValue: string = '';
  isCityText: boolean = false;
  submitted: boolean = false;
  isCustomClass: boolean = false;
  callerType: boolean = false;
  customerData: any[] | undefined;
  passerByData: any[] | undefined;
  otherData: any[] | undefined;
  advisoriesList!: any[];
  activeTabIndex: number = 0;
  isPopupVisible: boolean = false;
  isModalOpen: boolean = false;
  firstName: string = '';
  lastName: string = '';
  houseNumber: string = '';
  street: string = '';
  zip: string = '';
  phone: string = '';
  extension: string = '';
  accountno: string = '';
  ssn: string = '';
  dialogVisible: boolean = false;
  textboxStyle: string = 'textboxStyle';
  errorList: string[] = [];
  isValidate: boolean = false;
  SaveValidation: string = environment.appMessages.SaveValidation;
  saveSuccess: string = '';
  isSaveSuccess: boolean = false;
  isFormSubmitted: boolean = false;
  isSaveDisable: boolean = true;
  isSsnEnable: boolean = false;
  isCityValidate: boolean = false;
  callCheckListData: any = {};
  isCallCheckListEnable: boolean = false;
  callCheckListSelected: any;
  @ViewChild('formRef') formRef!: NgForm;
  isErrorMessage: boolean = false;
  advisoriesPayload!: AdvisoriesData[];
  isEmerComments: boolean = false;
  isInsideOrOutsideOption: boolean = false;
  genderValue: string = '';
  gender = ['Mr', 'Ms'];
  advisoriesOrderType!: string;
  isDisclosureChecked: boolean = false;
  isLeakageEnabled: boolean = false;
  customerRequest: string = '';
  @ViewChild('moveInForm') moveInForm!: MoveInComponent;
  moveInformData: any;
  @ViewChild('moveOutForm') moveOutForm!: MoveOutComponent;
  moveOutformData: any;
  dispatchListData: any = {};
  isFirstOrderNotice: boolean = false;
  ccrId: string = "";
  selectedQueryParamData: any = {};
  previousPath: any = '';
  processMessage: string = "";
  isPhoneNoValidate: boolean = false;
  isZipCodeValidate: boolean = false;
  isSsnValidate: boolean = false;
  isCallertypeactive: boolean = false;
  isDispatchActive: boolean = false;
  pageSize: number = 10;
  totalRecords: number = 2000;
  currentPage: number = 1;
  totalNumRecords: number = 0;
  OrderTypeValue: string = '';
  leakageTypeData = leakageTypeData;
  orderTypeConfig: any;

  constructor(private formBuilder: FormBuilder,
    private orderEntryService: OrderEntryService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private monotoringService: MyMonitoringService,
    private datePipe: DatePipe,
    private callChecklistService: CallCheckListService,
    private sanitizer: DomSanitizer,
    private router: Router,
    private apiService: ApiService,
    private orderEntrySharedService: OrderEntrySharedService
  ) { }


  ngOnInit(): void {
    this.showDiv = false;
    this.isPageLoad = false;
    this.isCity = false;
    this.isCityText = false;
    this.isSuccess = false;
    this.isSaveSuccess = false;
    this.getCityOrderAdvisories();
  }

  getCityOrderAdvisories() {
    const orderType$ = this.apiService.groupId().pipe(
      switchMap(groupId => this.orderEntryService.getOrderTypeData(groupId))
    );
    const city$ = this.apiService.groupId().pipe(
      switchMap(groupId => this.orderEntryService.getCityData(groupId))
    );
    const advisories$ = this.orderEntryService.getAdvisoriesData();
    this.isLoading = true;
    this.ccrId = this.route.snapshot.paramMap.get('ccrId') ?? "";
    if (this.ccrId != "") {
      const odrerById$ = this.orderEntryService.getOrderDataByCcrId(this.ccrId);
      forkJoin([city$, orderType$, advisories$, odrerById$])
        .subscribe({
          next: ([city, orderType, advisories, odrerById]) => {
            this.LoadCityData(city);
            this.GetOrderType(orderType);
            this.getAdvisoriesData(advisories);
            this.getOrderTypeDataByCcrId(odrerById);
            this.isLoading = false;
          },
          error: (error) => {
            this.isFailure = true;
            const errMsg = environment.appMessages.ServerError;
            this.messageService.add({ severity: 'error', summary: 'Failed', detail: errMsg });
            this.monotoringService.logException({ name: 'OrderEntryComponent.getCityOrderAdvisories', message: error }, SeverityLevel.Error);
            this.isLoading = false;
          },
          complete: () => {
            this.isLoading = false;
          }
        });
    }
    else {
      forkJoin([city$, orderType$, advisories$])
        .subscribe({
          next: ([city, orderType, advisories]) => {
            this.LoadCityData(city);
            this.GetOrderType(orderType);
            this.getAdvisoriesData(advisories);
            this.isLoading = false;
          },
          error: (error) => {
            this.isFailure = true;
            const errMsg = environment.appMessages.ServerError;
            this.messageService.add({ severity: 'error', summary: 'Failed', detail: errMsg });
            this.monotoringService.logException({ name: 'OrderEntryComponent.getCityOrderAdvisories', message: error }, SeverityLevel.Error);
            this.isLoading = false;
          },
          complete: () => {
            this.isLoading = false;
          }
        });
    }
  }


  onChangeOrderType(event: any) {
    var OrderTypeValue = event.trim().toLowerCase();
    if (OrderTypeValue === '') {
      this.isPageLoad = this.isCallCheckListEnable = false;
      return;
    }
    this.customerChecked = this.passerByChecked = this.otherChecked = false;
    const filters = ['eme', 'obw'];
    const data = OrderTypeValue.substring(0, 3);
    this.isCallCheckListEnable = filters.includes(data) && data === 'eme';
    this.isFormSubmitted = false;
    if (data === 'eme') {
      this.onLoadCallCheckList(event);
    }
    this.isSsnEnable = !filters.includes(data);
    this.isReconnect = event.includes('RECONNECT')
    this.orderTypeSelectedValue = event;
    this.showHidePhoneDiv(OrderTypeValue);
    this.isPageLoad = this.isCustomClass = true;
    this.isSaveDisable = this.isCallertypeactive = this.isDispatchActive = false;
  }

  LoadCityData(data: any) {
    this.orderEntrySharedService.setCityData(data);
    this.cityNamePayLoad = data.Payload
    this.isSuccess = true;
    this.CityDropdownOptions = this.cityNamePayLoad;
  }

  GetOrderType(data: any): void {
    this.orderEntrySharedService.setOrderTypeData(data);
    this.orderTypePayLoad = data.Payload
    this.orderTypeDropdownOptions = ControlUtils.buildDropDownOptions(this.orderTypePayLoad.filter(item => item.Code === 'OrderType').map(item => item.Value)
      .sort((a, b) => a.localeCompare(b)));
    this.StateDropdownOptions = ControlUtils.buildDropDownOptions(this.orderTypePayLoad.filter(item => item.Code === 'State').map(item => item.Value)
      .sort((a, b) => a.localeCompare(b)));
  }

  getAdvisoriesData(data: any) {
    this.advisoriesPayload = data.Payload;
  }

  onFormMoveInDataChange(data: any) {
    this.moveInformData = data;
  }

  onFormMoveOutDataChange(data: any) {
    this.moveOutformData = data;
  }

  onDateChange(event: any) {
    this.reconnectSelectedDate = event;
    this.reconnectformatedDate = this.datePipe.transform(this.reconnectSelectedDate, 'MM/dd/yyyy');
  }

  getFormattedData = (arr: any) => {
    const tempArr = [{ label: 'All', value: 'all' }]
    return [...tempArr, ...arr?.map((item: any) => ({ label: item, value: item?.toString()?.toLowerCase() }))];
  }

  handleTabChange(event: any) {
    this.activeTabIndex = event.index;
    if (this.activeTabIndex == 1) {
      this.isCallertypeactive = false;
      this.isDispatchActive = true;
    }
    else {
      if (this.customerChecked || this.passerByChecked || this.otherChecked) {
        this.isCallertypeactive = true;
        this.isDispatchActive = false;
      }
      else {
        this.isCallertypeactive = false;
        this.isDispatchActive = false;
      }

    }
  }

  onTextChange(input: any) {
  }

  onFirstNameChange(input: any) {
    this.firstName = input;
  }

  onLasttNameChange(input: any) {
    this.lastName = input;
  }

  onHouseNoChange(input: any) {
    this.houseNumber = input;
  }

  onStreetChange(input: any) {
    this.street = input;
  }

  onCityTextChange(input: any) {
    this.cityValue = input;
    this.isCityValidate = true;
  }

  onZipChange(input: any) {
    this.zip = input;
  }

  onPhoneChange(input: any) {
    this.phone = input;
  }

  onExtNoChange(input: any) {
    this.extension = input;
  }

  onAccNoChange(input: any) {
    this.accountno = input;
  }

  onSSNChange(input: any) {
    this.ssn = input;
  }

  onAdvisoriesData(orderType: any) {
    this.advisoriesOrderType = orderType;
    this.getAdvisorData(this.advisoriesType, orderType);
  }

  onLoadCallCheckList(event: any) {
    var OrderTypeValue = event.trim().toLowerCase();
    this.OrderTypeValue = OrderTypeValue;
    const data = OrderTypeValue.substring(0, 3)
    const isLeakageFilter = ['EMER-CO', 'EMER-LO/HI PRESSURE', 'EMER-NO GAS'];
    if (!isLeakageFilter.includes(event) && data === 'eme') {
      this.isEnableLeaked = true;
    }
    else {
      this.isEnableLeaked = false;
    }
    const isOrderNoticeFilter = ['EMER-BLOWING GAS', 'EMER-LEAK STREET'];
    if (!isOrderNoticeFilter.includes(event) && data === 'eme') {
      this.isFirstOrderNotice = true;
    }
    else {
      this.isFirstOrderNotice = false;
    }
    const isEmergencyFilter = this.orderTypePayLoad.filter(item => item.Code === 'OrderType'
      && item.Value.substring(0, 4) === 'EMER').map(v => v.Value);
    if (isEmergencyFilter.includes(event)) {
      this.isEmerComments = true;
    }
    else {
      this.isEmerComments = false;
    }
    const isLeakInOrOutsideFilter = ['EMER-EXPLOSION', 'EMER-LEAK INSIDE', 'EMER-LEAK OUTSIDE', 'EMER-PIPELINE'];
    if (isLeakInOrOutsideFilter.includes(event)) {
      this.isInsideOrOutsideOption = true;
    }
    else {
      this.isInsideOrOutsideOption = false;
    }
    this.onAdvisoriesData(event);
  }

  showHidePhoneDiv(OrderTypeValue: string) {
    if (OrderTypeValue.length > 3) {
      if (OrderTypeValue.substring(0, 4) === 'emer') {
        this.showDiv = true;
      }
      else {
        this.showDiv = false;
      }
    }
    else {
      this.showDiv = false;
    }
  }

  showDialog() {
    this.dialogVisible = true;
  }


  markCustomInputsAsTouched() {
    const customInputs = document.querySelectorAll('app-textinput');
    customInputs.forEach((input) => {
      (input as any).markAsTouched?.();
    });
  }

  mapCallCheckListData() {
    this.callCheckListPayload = new CallCheckListPayload();
    this.callCheckListPayload.additionalEmergency = this.callCheckListData.additionalEmergencyValue;
    this.callCheckListPayload.additionalOutsideLocation = this.callCheckListData.additionaloutsidelocation;
    this.callCheckListPayload.appliance = this.callCheckListData.applianceValue;
    this.callCheckListPayload.buildingSelected = this.callCheckListData.buildingSelectedValue;
    this.callCheckListPayload.callerTypes = this.callCheckListData.callerTypes;
    this.callCheckListPayload.isLeakAppliance = this.callCheckListData.isLeakApplianceValue;
    this.callCheckListPayload.isLeakHousePiping = this.callCheckListData.isLeakHousePipingValue;
    this.callCheckListPayload.leakageType = this.callCheckListData.leakageType == undefined ? '' : this.callCheckListData.leakageType;
    this.callCheckListPayload.leakedSelected = this.callCheckListData.leakedSelectedValue;
    this.callCheckListPayload.odorfirstnoticed = this.callCheckListData.odorfirstnoticed;
    this.callCheckListPayload.room = this.callCheckListData.roomValue;
    this.callCheckListPayload.soundGas = this.callCheckListData.soundGas;
    this.callCheckListPayload.type = this.callCheckListData.typeValue;
    this.callCheckListPayload.workInProgress = this.callCheckListData.workInProgressValue;
  }

  mapDispatchData() {


    this.dispatchDataPayload = new DispatchDataPayload();
    this.dispatchDataPayload.StatusUpdateNotes = this.dispatchListData.statusUpdateNotesValue;
    this.dispatchDataPayload.analystEntry = this.dispatchListData.analystEntryValue;
    this.dispatchDataPayload.dataInSap = this.dispatchListData.dataInSap;
    this.dispatchDataPayload.dispatchEntry = this.dispatchListData.dispatchEntryValue;
    this.dispatchDataPayload.dispatchFirstName = this.dispatchListData.dispatchFirstNameValue;
    this.dispatchDataPayload.dispatchLastName = this.dispatchListData.dispatchLastNameValue;
    this.dispatchDataPayload.sapWo = this.dispatchListData.sapWoValue;
    this.dispatchDataPayload.dispatchTechId = this.dispatchListData.dispatchTechIdValue;
  }

  newOrderEntry() {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/order-entry']);
    });
  }

  onSubmit(formValue: any) {
    this.isLoading = true;
    this.requestPayload = new RequestPayload();
    this.isFormSubmitted = true;
    this.isCallertypeactive = false;
    this.isDispatchActive = false;

    /* if (this.dispatchListData != null) {
       if (this.isValidateDispatchData()) {
         this.isLoading = false;
         return;
       }
     }*/
    if (formValue.invalid) {
      Object.keys(formValue.controls).forEach((key) => {
        formValue.controls[key].markAsTouched();
      });
      this.markCustomInputsAsTouched();
      this.isLoading = false;
      return;
    }

    if (this.orderTypeSelectedValue === 'TRANSFER') {
      const isMoveInValid = this.moveInForm.validateForm(this.isFormSubmitted);
      const isMoveOutValid = this.moveOutForm.validateForm(this.isFormSubmitted);
      if (!isMoveInValid || !isMoveOutValid) {
        this.isLoading = false;
        return;
      }
    }

    if (['NEW ACCOUNT', 'MOVE-IN'].includes(this.orderTypeSelectedValue)) {
      const isMoveInValid = this.moveInForm.validateForm(this.isFormSubmitted);
      if (!isMoveInValid) {
        this.isLoading = false;
        return;
      }
    }

    if (this.orderTypeSelectedValue === 'MOVE-OUT') {
      const isMoveOutValid = this.moveOutForm.validateForm(this.isFormSubmitted);
      if (!isMoveOutValid) {
        this.isLoading = false;
        return;
      }
    }

    if (this.ssn != '') {
      this.ssn = this.ssn.replaceAll('-', '');
      if (this.ssn.length != 9) {
        this.isSsnValidate = true;

      }
      else {
        this.isSsnValidate = false;
      }
    }
    if (this.phone != null || this.phone !== '') {
      this.phone = this.phone.replaceAll('-', '').replaceAll('(', '').replaceAll(')', '').replaceAll(' ', '');
      if (this.phone.length != 10) {

        this.isPhoneNoValidate = true;

      }
      else {
        this.isPhoneNoValidate = false;
      }
    }

    if (this.zip !== '') {
      if (this.zip.length < 5) {
        this.isZipCodeValidate = true;

      }
      else {
        this.isZipCodeValidate = false;
      }
    }
    if (this.isPhoneNoValidate || this.isZipCodeValidate || this.isSsnValidate) {
      this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Correct Phone, Zip, or SSN and try again Save.' });
      this.isLoading = false;
      return;
    }
    if (this.reconnectformatedDate != null || this.reconnectformatedDate !== '') {
      this.requestPayload.reqReconnectDt = this.reconnectSelectedDate;
    }
    else {
      this.requestPayload.reqReconnectDt = null;
    }

    this.requestPayload.CcrId = '';
    this.requestPayload.UpdateCcrId = '';

    if (this.ccrId != null) {
      this.requestPayload.CcrId = this.ccrId;
      this.requestPayload.UpdateCcrId = this.ccrId;
    }

    this.requestPayload.UserId = sessionStorage.getItem('userId');
    this.requestPayload.UserName = sessionStorage.getItem('userName');
    this.requestPayload.reconnectApptTm = '';
    this.requestPayload.orderType = this.orderTypeSelectedValue;
    this.requestPayload.firstName = this.firstName;
    this.requestPayload.lastName = this.lastName;
    this.requestPayload.houseNumber = this.houseNumber;
    this.requestPayload.street = this.street;
    this.requestPayload.city = this.citySelectedValue;
    this.requestPayload.state = this.stateSelectedValue;
    this.requestPayload.zip = this.zip;
    this.requestPayload.gender = this.genderValue;
    this.requestPayload.safePhone = this.phone;
    this.requestPayload.extension = this.extension;
    this.requestPayload.contractAccountNo = this.accountno;
    this.requestPayload.ssn = this.ssn;
    this.requestPayload.customerRequestInformation = this.customerRequest;
    this.requestPayload.newCity = this.cityValue

    if (['MOVE-IN', 'NEW ACCOUNT', 'TRANSFER'].includes(this.orderTypeSelectedValue) && this.moveInformData) {
      this.requestPayload.newSvcCity = this.moveInformData.NewSvcCity;
      this.requestPayload.newStreet = this.moveInformData.NewStreet;
      this.requestPayload.newState = this.moveInformData.NewState;
      this.requestPayload.newZip = this.moveInformData.NewZip;
      this.requestPayload.newMeterNumber = this.moveInformData.NewMeterNumber;
      this.requestPayload.newInstallationNumber = this.moveInformData.NewInstallationNumber;
      this.requestPayload.driverLicenseState = this.moveInformData.DriverLicenseState;
      this.requestPayload.driverLicenseNumber = this.moveInformData.DriverLicenseNumber;
      this.requestPayload.maritalStatus = this.moveInformData.MaritalStatus;
      this.requestPayload.setupInSpouseName = this.moveInformData.SetUpInSpouseName;
      this.requestPayload.Spouse_MR_MS = this.moveInformData.Spouse_MR_MS;
      this.requestPayload.SpouseLastName = this.moveInformData.SpouseLastName;
      this.requestPayload.SpouseFirstName = this.moveInformData.SpouseFirstName;
      this.requestPayload.newHouseNumber = this.moveInformData.NewHouseNumber;
      this.requestPayload.IsAutomaticBankDraft = this.moveInformData.IsAutomaticBankDraft;
      this.requestPayload.IsAverageMonthlyBilling = this.moveInformData.IsAverageMonthlyBilling;
      this.requestPayload.IsElderlyDisabled = this.moveInformData.IsElderlyDisabled;
      this.requestPayload.IsBudgetPlan = this.moveInformData.IsBudgetPlan;
      this.requestPayload.IsBadDebtAtPremise = this.moveInformData.IsBadDebtAtPremise;
      this.requestPayload.Comments = this.moveInformData.Comments;
      this.requestPayload.DepositAm = this.moveInformData.IsBadDebtAtPremise === "Yes" ? this.moveInformData.DepositAm : "0";
      this.requestPayload.spouseSSN = this.moveInformData.SpouseSSN !== "" ? this.moveInformData.SpouseSSN?.toString()?.replaceAll('-', '') : null;
      this.requestPayload.SvcToBeginDt = this.moveInformData.WorkDt ? new Date(this.moveInformData.WorkDt) : new Date(this.moveInformData.SvcToBeginDt);
    }

    if (['TRANSFER', 'MOVE-OUT'].includes(this.orderTypeSelectedValue) && this.moveOutformData) {
      this.requestPayload.oldStreet = this.moveOutformData?.OldStreet;
      this.requestPayload.oldCity = this.moveOutformData?.OldCity;
      this.requestPayload.oldState = this.moveOutformData?.OldState;
      this.requestPayload.oldZip = this.moveOutformData?.OldZip;
      this.requestPayload.oldMeterNumber = this.moveOutformData?.OldMeterNumber;
      this.requestPayload.oldInstallationNumber = this.moveOutformData?.OldInstallationNumber;
      this.requestPayload.OldHouseNumber = this.moveOutformData?.OldHouseNumber;
      this.requestPayload.reqReconnectDt = new Date();
      this.requestPayload.ReqToDisconnectDt = this.moveOutformData.ReqToDisconnectDt;
    }

    if (this.isCallChekList) {
      this.isLeakageEnabled = true;
      // if (this.callCheckListData.leakageType == 'Inside' &&
      //   (this.callCheckListData.buildingSelectedValue == '' ||
      //     this.callCheckListData.roomValue == null ||
      //     this.callCheckListData.applianceValue == null ||
      //     this.callCheckListData.isLeakApplianceValue == null ||
      //     this.callCheckListData.isLeakHousePipingValue == null
      //   )) {
      //   this.isLoading = false;
      //   return;
      // }
      // if (this.callCheckListData.leakageType == 'Outside' &&
      //   this.callCheckListData.leakedSelectedValue == ''
      // ) {
      //   this.isLoading = false;
      //   return;
      // }
      this.mapCallCheckListData();
      this.requestPayload.callCheckList = this.callCheckListPayload;
    }
    else {
      this.requestPayload.callCheckList = null;
    }
    this.mapDispatchData();
    this.requestPayload.dispatchData = this.dispatchDataPayload;
    const userId = sessionStorage.getItem('userId');
    const userName = sessionStorage.getItem('userName');
    if (this.requestPayload.orderType == 'MISC' || this.requestPayload.orderType == 'OBW') {
      this.requestPayload.callCheckList = null;
    }

    if (this.dispatchDataPayload != null && this.dispatch != null) {
      this.requestPayload.isDispatchChanged = this.isObjectValueChangedCaseInsensitive(this.dispatchDataPayload, this.dispatch);
    }

    if (this.callCheckListPayload != null && this.emergencies != null) {
      this.emergencies.CallerTypes = this.emergencies.CallerTypes == null ? '' : this.emergencies.CallerTypes;
      this.requestPayload.isCustomercallChanged = this.isObjectValueChangedCaseInsensitive(this.callCheckListPayload, this.emergencies);
    }
    this.requestPayload.dispatchData = this.dispatchDataPayload;
    this.saveCustomerData(this.requestPayload);
  }

  orderTypDataChange(event: any) {
    this.orderTypeSelectedValue = event;
    this.showDiv = true;
    this.isPageLoad = true;
    this.isCustomClass = true;
  }

  onGenderChange(event: any) {
    this.genderValue = event;
  }

  OnbuildingChanged(event: any) {
    this.buildingSelectedValue = event.target.value;
  }

  OnleakedChanged(event: any) {
    this.leakedSelectedValue = event.target.value;
  }

  OnStateChanged(event: any) {
    this.stateSelectedValue = event;
    this.isCity = true;
    this.isCityText = false;
    this.citySelectedValue = '';
    this.CityDropdownOptions = ControlUtils.buildDropDownOptions(this.cityNamePayLoad.filter(option => option.State.toLowerCase().includes(event.toLowerCase()))
      .map(option => option.City));
  }

  OnCityChanged(event: any) {
    this.citySelectedValue = event;
    this.isCityValidate = true;
  }

  orderTypChanged() {
    this.showDiv = true;
    this.isPageLoad = true;
  }

  cityClick() {
    this.isCityText = true;
  }

  LoadEditCityData(state: any, city: any) {
    this.apiService.groupId().pipe(
      switchMap(groupId => this.orderEntryService.getCityData(groupId))
    ).subscribe({
      next: (data: { Payload: CityLoadData[]; }) => {
        this.cityNamePayLoad = data.Payload
        this.isSuccess = true;
        // this.CityDropdownOptions = this.cityNamePayLoad;
        this.CityDropdownOptions = this.cityNamePayLoad.filter(option => option.State.toLowerCase().includes(state.toLowerCase()))
          .map(option => option.City);
        this.citySelectedValue = city;
        this.setDefaultSelectedValue();
      },
      error: (error: string) => {
        //  this.isLoading = false;
        this.isFailure = true;
        const errMsg = environment.appMessages.ServerError;
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: errMsg });
        this.monotoringService.logException({ name: 'OrderEntryComponent.LoadEditCityData', message: error }, SeverityLevel.Error);
      },
      complete: () => {
        //  this.isLoading = false;
      }
    });
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['CityDropdownOptions']) {
      this.setDefaultSelectedValue();
    }
  }

  setDefaultSelectedValue() {
    if (this.CityDropdownOptions.length) {
      //const selectedCity = this.CityDropdownOptions.find(city => city.cityId === 'test');
    }
  }


  sanitizeHtml(htmlString: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(htmlString);
  }



  onPageLoad() {
    if (this.isOrderUpdate) {
      const lsQueryData = JSON.parse(sessionStorage.getItem("queryData")!);

      if (lsQueryData) {

        this.router.navigate([lsQueryData.from])
      }
      else {
        window.location.reload();
      }

    }
    else {
      window.location.reload();
    }
  }


  saveCustomerData(request: any): void {
    this.isLoading = true;
    this.customerChecked = false;
    this.passerByChecked = false;
    this.otherChecked = false;
    const payload = {
      orderEntryRequest: request,
      orderEntryNewSvcRequest: request,
      orderEntryOldAddressRequest: request
    }

    this.orderEntryService.saveOrder(payload).pipe(
      switchMap((response: any) => {
        if (this.ccrId != "") {
          this.orderEntryService.getOrderDataByCcrId(this.ccrId).subscribe(res => this.getOrderTypeDataByCcrId(res))
        }
        return of(response);
      })
    ).subscribe({
      next: (data: any) => {
        const httpStatusCode = data?.status;
        if (httpStatusCode === 400) {
          const errMsg = data?.error?.ResultDescription;
          this.messageService.add({ severity: 'error', summary: 'Failed', detail: errMsg });
        } else {
          this.isSuccess = true;
          if (data.Payload == 'RecordExist') {
            this.saveSuccess = environment.appMessages.RecordExist + this.orderTypeSelectedValue + ' order.';
          }
          else {
            this.saveSuccess = environment.appMessages.saveSuccess + this.orderTypeSelectedValue + ' order.';
            this.isOrderUpdate = true;
            this.isOrderEntry = 'Order Update';

            const pageTitle = document.querySelector('.page-title');
            if (pageTitle instanceof HTMLElement) {
              pageTitle.textContent = 'Order Update';
            }

            this.messageService.add({ severity: 'success', summary: 'Successful', detail: this.saveSuccess ?? environment.appMessages.saveSuccess, life: environment.appSettings.snakbarLife });
            this.ccrId = data.CCRID;
            this.isCallertypeactive = false;
            this.phone = this.formatPhoneNumber(this.phone);
            this.isDispatchActive = false;
          }
        }
      },
      error: (error) => {
        this.isLoading = false;
        this.isFailure = true;
        const errMsg = environment.appMessages.errorSaving;
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: errMsg });
        this.monotoringService.logException({ name: 'OrderEntryComponent.saveCustomerData', message: error }, SeverityLevel.Critical);
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }


  onReset(): void {
    this.submitted = false;
  }

  onConfirm() {
    this.isPopupVisible = false;
  }

  onCancel() {
    this.isPopupVisible = false;
  }

  openModal() {
    this.isModalOpen = true;
  }

  closeModal() {
    this.isModalOpen = false;
  }

  handleFormValuesChange(values: any) {
    this.reconnectSelectedDate = values.reconnectSelectedDate;
    this.reconnectformatedDate = values.reconnectformatedDate;
  }

  handleCallChecListFormValues(formValues: any) {
    this.callCheckListData = formValues;
    this.isCallChekList = true;
    this.callCheckListSelected = true;
  }

  handleCallChecListFormValidity(isValid: boolean) {
    this.isChildFormValid = isValid;
  }
  customerChecked: boolean = false;
  passerByChecked: boolean = false;
  otherChecked: boolean = false;

  handleCallerTypeChange(selectedType: string): void {
    this.getAdvisorData(selectedType, this.advisoriesOrderType);
  }
  advisoriesType!: string;
  getAdvisorData(selectedType: string, orderType: string): void {
    this.advisoriesType = selectedType;
    this.isCallertypeactive = true;
    this.isDispatchActive = false;
    this.customerData = this.advisoriesList = this.advisoriesPayload.filter(item => item.CallerType?.trim().toUpperCase() === Appconstants.CUSTOMERCALLERTYPE).
      filter(item => item.OrderType === orderType).sort((a, b) => a.ListOrder - b.ListOrder).map(({ Advisories, Checked }) => ({ Advisories, Checked }));
    this.passerByData = this.advisoriesPayload.filter(item => item.CallerType?.trim().toUpperCase() === Appconstants.PASSERBYCALLERTYPE).filter(item => item.OrderType === orderType).sort((a, b) => a.ListOrder - b.ListOrder).map(({ Advisories, Checked }) => ({ Advisories, Checked }));
    this.otherData = this.advisoriesPayload.filter(item => item.CallerType?.trim().toUpperCase() === Appconstants.OTHERCALLERTYPE).filter(item => item.OrderType === orderType).sort((a, b) => a.ListOrder - b.ListOrder).map(({ Advisories, Checked }) => ({ Advisories, Checked }));
    this.customerChecked = selectedType === 'Customer';
    this.passerByChecked = selectedType === 'Passer By';
    this.otherChecked = selectedType === 'Other';
    if (this.customerChecked) {
      this.advisoriesList = this.customerData;
    } else if (this.passerByChecked) {
      this.advisoriesList = this.passerByData;
    } else if (this.otherChecked) {
      this.advisoriesList = this.otherData;
    }
    this.advisoriesList = this.rearrangeList(this.advisoriesList, 'Reminder');
  }
  isChildFormValid: boolean = false;
  childFormData: any = {};
  isEnableLeaked: boolean = false;

  isFormValid(): boolean {
    if (this.isSaveDisable || this.formRef.invalid || !this.stateSelectedValue || !this.isCityValidate) {
      return true;
    }

    // Validate based on order type
    switch (this.orderTypeSelectedValue) {
      case 'MOVE-IN':
      case 'NEW ACCOUNT':
        if (!this.moveInForm?.validateForm(this.isFormSubmitted)) {
          return true;
        }
        break;

      case 'MOVE-OUT':
        if (!this.moveOutForm?.validateForm(this.isFormSubmitted)) {
          return true;
        }
        break;

      case 'TRANSFER':
        if (!this.moveInForm?.validateForm(this.isFormSubmitted) ||
          !this.moveOutForm?.validateForm(this.isFormSubmitted)) {
          return true;
        }
        break;
    }

    // Validate call checklist if enabled
    if (this.isCallCheckListEnable && !this.ValidateCallChecklist()) {
      return true;
    }

    return false;
  }

  ValidateCallChecklist() {
    const orderTypeConfig = this.leakageTypeData.config.find(d => d.orderTpe.toLowerCase()
      === this.OrderTypeValue.toLowerCase());
    this.orderTypeConfig = orderTypeConfig;
    var areAllAdvisoriesSelected = true;
    if (this.advisoryDiv?.nativeElement != undefined) {
      const advisoryChkBoxes = this.advisoryDiv?.nativeElement.querySelectorAll('input[type="checkbox"]');
      advisoryChkBoxes.forEach((advisoryChkBox: HTMLInputElement) => {
        if (!advisoryChkBox.checked) {
          areAllAdvisoriesSelected = false;
          return;
        }
      });
    }

    if (!areAllAdvisoriesSelected) {
      return false;
    }

    if (this.callCheckListData.callerTypes == null) {
      return false;
    }
    // if (this.callCheckListData.odorfirstnoticed == null ||
    //   this.callCheckListData.soundGas == null) {
    //   return false;
    // }


    if (orderTypeConfig?.leakageRequired
      && this.isStringEmptyOrNullUndefined(this.callCheckListData.leakageType)
    ) {
      return false;
    }


    if (this.callCheckListData.leakageType == 'Inside') {
      if ((orderTypeConfig?.inside.typeOfBuildingRequired &&
        this.isStringEmptyOrNullUndefined(this.callCheckListData.buildingSelectedValue)) ||

        (orderTypeConfig?.inside.whichRoomRequired &&
          this.isStringEmptyOrNullUndefined(this.callCheckListData.roomValue)) ||

        (orderTypeConfig?.inside.isLeakAtApplianceRequired &&
          this.isStringEmptyOrNullUndefined(this.callCheckListData.isLeakApplianceValue)) ||

        (orderTypeConfig?.inside.applianceRequired &&
          this.callCheckListData.isLeakApplianceValue !== Appconstants.No &&
          this.isStringEmptyOrNullUndefined(this.callCheckListData.applianceValue)) ||

        (orderTypeConfig?.inside.leakInHousePipingRequired &&
          this.isStringEmptyOrNullUndefined(this.callCheckListData.isLeakHousePipingValue))
      ) {
        return false;
      }
    }

    if (this.callCheckListData.leakageType == 'Outside') {
      if (
        (orderTypeConfig?.outSide.whereLeakLocatedRequired &&
          this.isStringEmptyOrNullUndefined(this.callCheckListData.leakedSelectedValue)
        ) ||
        (orderTypeConfig?.outSide.addLocationCommentsRequired &&
          this.isStringEmptyOrNullUndefined(this.callCheckListData.additionaloutsidelocation)
        )
      ) {
        return false;
      }
    }
    if (this.isEmerComments) {
      if (!this.callCheckListData.additionalEmergencyValue ||
        this.callCheckListData.additionalEmergencyValue.trim().length === 0
      ) {
        return false;
      }
    }


    return true;
  }

  isStringEmptyOrNullUndefined(str: string | null | undefined): boolean {
    return !str;
  }


  openConfirmationPopup() {
    this.isErrorMessage = false;
  }

  closePopup() {
    this.isErrorMessage = false;
  }

  rearrangeList(list: { Advisories: string; checked: boolean }[], searchText: string) {
    const itemsWithText = list.filter(item => item.Advisories.includes(searchText));
    const itemsWithoutText = list.filter(item => !item.Advisories.includes(searchText));
    return [...itemsWithoutText, ...itemsWithText];
  }

  oncustomerRequestChange(Val: string) {
    if (typeof Val === 'string') {
      this.customerRequest = Val;
    }
  }
  handleDispatchFormValues(formValues: any) {
    this.dispatchListData = formValues;

    this.isSaveDisable = this.isValidateDispatchData()

  }

  isValidateDispatchData() {
    const errMsg = environment.appMessages.SAPWORequired;
    if (this.dispatchListData.dataInSap == Appconstants.Yes && (this.dispatchListData.sapWoValue == '' || this.dispatchListData.sapWoValue.length == 0)) {
      this.isSaveSuccess = false;
      // this.messageService.add({ severity: 'error', summary: 'Failed', detail: errMsg });
      return true;
    }

    const dispatchTypes = ['Dispatched', 'Tecod'];
    const srvTecherrMsg = environment.appMessages.ServiceTechRequired;
    if (dispatchTypes.includes(this.dispatchListData.dispatchEntryValue)) {
      if (this.dispatchListData.dispatchFirstNameValue == ''
        || this.dispatchListData.dispatchLastNameValue == ''
      ) {
        this.isSaveSuccess = false;
        // this.messageService.add({ severity: 'error', summary: 'Failed', detail: srvTecherrMsg });
        return true;
      }
    }
    return false;
  }
  orderData: ApiResponse | undefined;
  customerCallRecord!: CustomerCallRecord;
  customerNewServiceRecord!: any;
  customerOldSvcAddressRecord!: any;
  emergencies!: Emergencies;
  dispatch!: Dispatch;
  isOrderUpdate: boolean = false;
  isOrderEntry: string = this.isOrderUpdate === true ? 'Order Entry Update' : 'Order Entry';
  historyLogs$!: Observable<HistoryLogs[]>;
  reconnectDate: Date | null = null;

  loadOrderEntryData() {
    this.LoadEditCityData(this.customerCallRecord.State, this.customerCallRecord.City);
    this.isOrderUpdate = true;
    this.isOrderEntry = 'Order Update';
    this.isCityValidate = true;
    this.onChangeOrderType(this.customerCallRecord.OrderType);
    this.firstName = this.customerCallRecord.FirstName;
    this.lastName = this.customerCallRecord.LastName;
    this.houseNumber = this.customerCallRecord.HouseNumber;
    this.genderValue = this.customerCallRecord.Gender;
    this.cityValue = this.customerCallRecord.NewCity;
    this.stateSelectedValue = this.customerCallRecord.State;
    this.street = this.customerCallRecord.Street;
    this.zip = this.customerCallRecord.Zip;
    this.phone = this.formatPhoneNumber(this.customerCallRecord.SafePhone);
    this.extension = this.customerCallRecord.Extension;
    this.accountno = this.customerCallRecord.ContractAccountNo;
    this.customerRequest = this.customerCallRecord.CustomerRequestInformation;
    this.CityDropdownOptions = this.cityNamePayLoad;
    this.ssn = this.customerCallRecord.Ssn;
    this.reconnectDate = this.customerCallRecord.ReqReconnectDt;
    this.OnStateChanged(this.customerCallRecord.State);
    this.isCity = true;
    this.isCityText = false;
  }

  getOrderTypeDataByCcrId(data: any): void {
    this.processMessage = environment.appMessages.loadingMesage;
    this.orderData = data;
    this.emergencies = data.Payload.emergencies;
    this.customerCallRecord = data.Payload.customerCallRecord
    this.customerNewServiceRecord = this.moveInformData = {
      ...data.Payload.CustomerNewServiceRecord,
      WorkDt: data.Payload.customerCallRecord.WorkDt
    }
    this.customerOldSvcAddressRecord = this.moveOutformData = {
      ...data.Payload.CustomerOldSvcAddressRecord,
      ReqReconnectDt: data.Payload.CustomerOldSvcAddressRecord?.ReqToDisconnectDt ?? data.Payload.customerCallRecord.ReqReconnectDt
    }
    this.dispatch = data.Payload.dispatch;
    this.historyLogs$ = of(data.Payload.historyLogs.Data);
    this.totalNumRecords = data.Payload.historyLogs.TotalRecords;
    this.isSuccess = true;
    this.loadOrderEntryData();
    this.onChangeOrderType({ event: data.Payload.customerCallRecord?.OrderType });
  }

  getCheckboxItem(currentIndex: any) {
    return currentIndex === this.advisoriesList?.length - 1;
  }

  onAdvisoriesChange(event: any) {
    this.AreAllAdvisoriesSelected();
  }

  AreAllAdvisoriesSelected() {
    if (this.advisoryDiv?.nativeElement != undefined) {
      const advisoryChkBoxes = this.advisoryDiv?.nativeElement.querySelectorAll('input[type="checkbox"]');
      advisoryChkBoxes.forEach((advisoryChkBox: HTMLInputElement) => {
        if (!advisoryChkBox.checked) {
          this.isSaveDisable = false;
          return;
        }
      });
    }
  }

  isObjectValueChangedCaseInsensitive(obj1: Record<string, any>, obj2: Record<string, any>): boolean {
    const normalize = (obj: Record<string, any>) =>
      Object.entries(obj).reduce((acc, [key, value]) => {
        acc[key.toLowerCase()] = value;
        return acc;
      }, {} as Record<string, any>);
    const norm1 = normalize(obj1);
    const norm2 = normalize(obj2);
    const allKeys = new Set([...Object.keys(norm1), ...Object.keys(norm2)]);

    for (const key of allKeys) {
      if (norm1[key] !== norm2[key]) {
        return true;
      }
    }
    return false;
  }


  formatPhoneNumber(input: string | null | undefined): string {
    if (!input || input.trim() === '') {
      return '';
    }
    const inputValue = input.replace(/\D/g, '');
    let formattedValue = '';
    if (inputValue.length > 0) {
      formattedValue = `(${inputValue.substring(0, 3)}`;
    }
    if (inputValue.length > 3) {
      formattedValue += `) ${inputValue.substring(3, 6)}`;
    }
    if (inputValue.length > 6) {
      formattedValue += `-${inputValue.substring(6, 10)}`;
    }
    return formattedValue;
  }
}